import { createStore } from "vuex";
import UIModule from "@/store/ui/UIModule";
import AuthModule from "@/store/auth/authModule";
const STORAGE_KEY = process.env.VUE_APP_STORE_KEY;
export default createStore({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    auth: AuthModule,
    ui: UIModule,
  },
  plugins: [
    (store) => {
      store.subscribe(() => {
        //console.log("saving storage")
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(store.state));
      });
    },
  ],
});
